module.exports = __webpack_public_path__ + "img/sml_sympton_icon.8883de4.png";